'use strict';
import React from 'react';
import ReactDOM from 'react-dom';

import LeagueRankingCard from "./LeagueRankingCard";
import LeagueRankingFilters from "./LeagueRankingFilters";


class LeagueRanking extends React.Component {
    constructor(props) {
        super(props);

        this.state = leagueRanking;
        this.fullRanking = leagueRanking.ranking;

        this.orderRanking = this.orderRanking.bind(this);
        this.includeGuest = this.includeGuest.bind(this);
    }

    componentDidMount() {
        this.orderRanking("score");
    }

    includeGuest(event) {
        this.state.includeGuest = event.target.checked;

        this.orderRanking(this.state.active_order, true);
    }

    orderRanking(event, update = false) {
        let order = typeof event === 'string' ? event : event.target.value;

        switch(order) {
            case 'score':
                order = "total_score";
                break;
        }

        let ranking = JSON.parse(JSON.stringify(this.fullRanking));

        if (!this.state.includeGuest) {
            ranking = ranking.filter((el) => el.user !== null);
        }

        this.setState({
            active_order: order,
            ranking:  ranking.sort((a,b) => {
                if(a['played'] === 0) { return 1; }
                if(b['played'] === 0) { return -1; }

                if (parseFloat(a[order]) > parseFloat(b[order])) {
                    return -1;
                }
                if (parseFloat(a[order]) < parseFloat(b[order])) {
                    return 1;
                }

                //In case of total score, we add more level of ordering:
                if(order === "total_score") {
                    //Order by wins
                    if (parseInt(a['won']) > parseInt(b['won'])) {
                        return -1;
                    }
                    if (parseInt(a['won']) < parseInt(b['won'])) {
                        return 1;
                    }

                    //Order by positive score
                    if (parseInt(a['positive_score']) > parseInt(b['positive_score'])) {
                        return -1;
                    }
                    if (parseInt(a['positive_score']) < parseInt(b['positive_score'])) {
                        return 1;
                    }
                }

                return 0;
            })
        }, () => {
            if(update) {
                window.destroyPlayerStatsModal();
                window.initPlayerStatsModal();
            }
        });
    }

    render() {
        const that = this;
        const labels = this.state.labels;
        const sportLabels = this.state.sport_labels;
        const sportRoles = this.state.sport_roles;
        const scoreByPoints = this.state.score_by_points;
        const order = this.state.active_order;

        return (
            <React.StrictMode>
                <LeagueRankingFilters labels={labels} sportLabels={sportLabels} orderRanking={that.orderRanking} includeGuest={that.includeGuest} orders={this.state.orders}/>

                {this.state.ranking.map((ranking, index) => (
                    <LeagueRankingCard index={index} ranking={ranking} labels={labels} sportLabels={sportLabels} sportRoles={sportRoles} scoreByPoints={scoreByPoints} order={order}/>
                ))}
            </React.StrictMode>
        );
    }
}

export default LeagueRanking;

if (document.getElementById('league-ranking')) {
    ReactDOM.render(<LeagueRanking />, document.getElementById('league-ranking'));
}
